import $ from 'jquery';
import _ from 'underscore';
import autosize from 'lib/autosize';
import ajax from 'util/ajax';
import { setAnalyticsEvents, track } from 'util/analytics';
import {
    $body,
    $window,
    jqGetElemById,
    isMobile,
    jqOffOn,
    setScrollPosition,
    supportsAnimation,
    userIsAuthenticated,
} from 'util/global';
import { crop, getScrollHeight, keyboardNavigation, showConfirmationModal } from 'util/ui';
import * as urls from 'util/urls';
import {
    CLASS_NAME_HIDE,
    INTERACTION_TYPES,
    EVT_QUIZ_POSITION_DID_CHANGE,
    QUIZ_CHAPTER_INTRO_STATE,
    CMP_RELOADING_FLAGS,
} from 'util/constants';
import { initGenericControllers } from 'app/generic_controllers';
import { twinklingStars } from 'app/paid';
import preloaders from 'app/preloaders';
import { practiceAnonWrapper } from 'app/solvables';


/** @module */
const Quiz = {};

/**
 * Controller to highlight related concept quiz in quiz map
 * after answering challenge problem incorrectly or viewing solution
 */
Quiz.recommendConceptQuiz = ($container) => {
    const recommendedQuizId = $container.data('recommended-quiz');
    jqGetElemById(`concept-quiz-${recommendedQuizId}`).addClass('recommended');
};


let finishQuizInfo = null;

function initFinishQuizTrigger() {
    jqOffOn(finishQuizInfo.$trigger, 'click.quizendstate', () => {
        const controller = finishQuizInfo.originalController;
        controller(finishQuizInfo.$container, finishQuizInfo.$trigger);
    });
}


/**
 * Wait until the user clicks the finish quiz button before showing the quiz endstate.
 * @param {function} originalController - existing controller
 * @return {function} a controller that will wait until the user clicks the finish quiz button
 *  before executing the original controller
 */
function finishQuizDecorator(originalController) {
    return function finishQuizFunctionWrapper($container) {
        _.defer(() => {
            const $trigger = jqGetElemById('endstate-trigger-btn');
            if ($trigger.length) {
                finishQuizInfo = {
                    $trigger,
                    $container,
                    originalController,
                };
            }

            if (finishQuizInfo === null || !finishQuizInfo.$trigger.length) {
                return;
            }

            if ($trigger.data('show-immediately')) {
                originalController($container, $trigger);
            }

            initFinishQuizTrigger();
        });
    };
}


/**
 * Create a countdown for a given element
 * @param {JQuery} $element
 * @param {Function} callback - called when the countdown is done
 * @return {Object} object containing a function to stop the countdown
 */
var countdownForElement = function ($element, callback) {
    if (!$element.length) {
        return null;
    }
    var tmpl = _.template($element.data('tmpl'));
    var start = (new Date()).getTime();
    var totalSeconds = 10;
    var interval = setTimeout(function () {
        interval = setInterval(function () {
            var elapsedSeconds = Math.round(((new Date()).getTime() - start) / 1000);
            var remainingSeconds = totalSeconds - elapsedSeconds;
            $element.text(tmpl({
                s: remainingSeconds
            }));
            if (remainingSeconds <= 0) {
                clearInterval(interval);
                callback($element);
            }
        }, 250);
    }, 500);

    return {
        stop: () => {
            clearInterval(interval);
            clearTimeout(interval);
        },
        reset: () => {
            $element.text(tmpl({
                s: totalSeconds,
            }));
        },
    };
};


/**
 * Apply scrollable class if .content is scrollable
 * @param {JQuery} $container
 */
function checkSalesCardOverflow($container) {
    const $content = $container.find('.content');
    const check = () => {
        if (getScrollHeight($content) > $content.outerHeight()) {
            $content.addClass('scrollable');
        }
    };
    $content.find('img').on('load', check);
    check();
}


/**
 * Quiz endstate (and sales card) modal controller
 * @param {JQuery} $modal
 */
Quiz.endstateModal = finishQuizDecorator(function ($modal) {
    $modal = $modal.clone(true);

    var countdown;
    var data = $modal.data();
    var next = function () {
        if (data.nextAction === 'paywall') {
            $modal.addClass(supportsAnimation() ? 'flipped' : 'force-flipped');
            $.get(data.nextUrl, {
                element_id: 'clicked_b2_next_quiz',
                target_object_id: data.targetObjectId,
                target_object_type: 'quiz',
                target_object_referrer:
                    encodeURIComponent(window.location.pathname + window.location.search)
            });
        } else {
            window.location.href = data.nextUrl;
        }
    };

    countdown = countdownForElement($modal.find('.countdown span'), next);
    if (countdown) {
        $modal.on('hide', () => {
            countdown.stop();
            countdown.reset();
        });
        $modal.find('a,button').on('click', countdown.stop);
    }
    $modal.find('.flip').on('click', next);

    $modal.on('show', function () {
        _.defer(function () {
            $modal.parent().addClass('b2-endstate-modal-backdrop');

            checkSalesCardOverflow($modal);
        });
    });

    $modal.modal();
    setAnalyticsEvents($modal);
});

Quiz.endstateTakeover = finishQuizDecorator(($container) => {
    if ($container.parents('.course-quiz-wrapper').length === 0) {
        $('.course-quiz-wrapper').find('.prac-solvable').append($container);
    }
    $container.parents('.course-quiz-wrapper').addClass('show-quiz-endstate');

    if (isMobile) {
        setScrollPosition(0);
    }
    twinklingStars($container.find('.endstate'));

    countdownForElement($container.find('.countdown span'), () => {
        let url = $container.data('next-url');
        if (url) {
            window.location.href = url;
        }

    });
});

/**
 * Show the quiz modal once per page load
 * @param {JQuery} $modal
 */
Quiz.preemptiveWiki = (function () {
    let viewedModal = false;
    return function ($modal) {
        if (viewedModal) {
            return;
        }

        const trackingPrefix = $modal.data('ax-prefix');
        const setNumber = jqGetElemById('quiz-wrapper').data('set-number');

        const trackEvent = eventType => () => {
            track('ui', {
                action: 'modal',
                element_type: 'modal',
                element_id: `${trackingPrefix}_${eventType}`,
                path: window.location.pathname,
                full_path: window.location.pathname + window.location.search,
            });
        };

        const $link = $modal.find('a');
        $link.attr('href', urls.appendGetParam($link.attr('href'), 'sn', setNumber));

        $modal.on('show', trackEvent('displayed'));
        $modal.on('hide', trackEvent('closed'));

        $modal.modal();
        viewedModal = true;
    };
})();


/**
 * Controller.
 * @param {JQuery} $pane
 */
Quiz.editablePane = ($pane) => {
    let $editBtn = $pane.find('.pane-edit-trigger');
    const $cancelBtn = $pane.find('.pane-cancel-editing');
    const $saveBtn = $pane.find('.pane-save-trigger');
    const $previewBtn = $pane.find('.pane-preview-trigger');
    const $isPreviewField = $pane.find('[name="preview"]');
    const isPreview = $pane.hasClass('is-previewing-pane');

    /**
     * Whether the form actually saves changes or just returns a preview is controlled with
     * a boolean field which sometimes needs to be adjusted manually before submitting.
     * @param {Boolean} isPreviewMode - true if the form needs to return a preview first
     */
    const togglePreviewMode = (isPreviewMode) => {
        $isPreviewField.val(isPreviewMode.toString());
    };

    if ($editBtn.length === 0) {
        $editBtn = $('.pane-edit-trigger');
    }
    $editBtn.on('click', (e) => {
        e.preventDefault();
        $pane.toggleClass('editing');

        togglePreviewMode(true);

        const $textarea = $pane.find('textarea');
        autosize($textarea);
    });

    $cancelBtn.on('click', (e) => {
        e.preventDefault();
        if (isPreview) {
            const data = $pane.data();
            showConfirmationModal({ title: data.cancelConfirmText })
                .then((confirmed) => {
                    if (confirmed) {
                        // reload pane component to revert changes
                        const { cmpUrl, cmpKey, pageKey, paramKey } = data;
                        $body.data(CMP_RELOADING_FLAGS.PANE, true);
                        ajax(pageKey).get(cmpUrl, {
                            component_key: cmpKey,
                            param_key: paramKey,
                        });
                    }
                });
        } else {
            $pane.toggleClass('editing');
        }
    });

    $saveBtn.on('click', (e) => {
        const isSaveMode = $isPreviewField.val() === 'false';
        if (!isSaveMode) {
            const data = $pane.data();
            e.preventDefault();
            showConfirmationModal({ title: data.saveConfirmText })
                .then((confirmed) => {
                    if (confirmed) {
                        togglePreviewMode(false);
                        $saveBtn.parents('form').trigger('submit');
                    }
                });
        }
    });

    $previewBtn.on('click', () => {
        togglePreviewMode(true);
    });
};

Quiz.replaceContinueButton = function ($container) {
    if (finishQuizInfo !== null) {
        initFinishQuizTrigger();
        $container.find('.solv-done-btn, .btn-next').filter(':visible').replaceWith(finishQuizInfo.$trigger.clone(true));
    }
};

module.exports = Quiz;
